import { AdminLayoutWithAuth } from "@/components/layout/AdminLayout/AdminLayout";
import { LoginLayout } from "@/components/layout/LoginLayout/LoginLayout";
import AdminAuthCallback from "@/pages/auth/AdminAuthCallback";
import Login from "@/pages/auth/Login";
import Logout from "@/pages/auth/Logout";
import Recover from "@/pages/auth/Recover";
import Register from "@/pages/auth/Register";
import ResetPassword from "@/pages/auth/ResetPassword";
import Chat from "@/pages/chat/Chat";
import CompanyCreate from "@/pages/company/CompanyCreate";
import CompanyDetail from "@/pages/company/CompanyDetail";
import CompanyEdit from "@/pages/company/CompanyEdit";
import CompanyList from "@/pages/company/CompanyList";
import ContactDetail from "@/pages/contact/ContactDetail";
import ContactList from "@/pages/contact/ContactList";
import ContactTypeCreate from "@/pages/contact/ContactTypeCreate";
import ContactTypeEdit from "@/pages/contact/ContactTypeEdit";
import ConvertDetail from "@/pages/convert/ConvertDetail";
import ConvertHistoryList from "@/pages/convert/ConvertHistoryList";
import ConvertList from "@/pages/convert/ConvertList";
import Home from "@/pages/home/Home";
import Information from "@/pages/information/Information";
import InformationCreate from "@/pages/information/InformationCreate";
import InformationEdit from "@/pages/information/InformationEdit";
import MasterDataDetail from "@/pages/master-data/MasterDataDetail";
import MasterDataList from "@/pages/master-data/MasterDataList";
import OrganizationTypeSelect from "@/pages/organization/OrganizationTypeSelect";
import PageNotFound from "@/pages/PageNotFound";
import RsoCreate from "@/pages/Rso/RsoCreate";
import RsoDetail from "@/pages/Rso/RsoDetail";
import RsoEdit from "@/pages/Rso/RsoEdit";
import RsoList from "@/pages/Rso/RsoList";
import ServerErrorPage from "@/pages/ServerErrorPage";
import Setting from "@/pages/system-setting/Setting";
import { AppRoutes } from "@/routes/config";
import { guestLoader } from "@/routes/authLoader";
import { RouteObject } from "react-router-dom";

export const routes: RouteObject[] = [
  {
    element: <LoginLayout />,
    children: [
      {
        path: AppRoutes.recover,
        element: <Recover />,
        loader: guestLoader,
      },
      {
        path: AppRoutes.resetPassword,
        element: <ResetPassword />,
      },
      {
        path: AppRoutes.login,
        element: <Login />,
        loader: guestLoader,
      },
      {
        path: AppRoutes.register,
        element: <Register />,
      },
      {
        path: AppRoutes.adminAuthCallback,
        element: <AdminAuthCallback />,
      },
    ],
  },
  {
    element: <AdminLayoutWithAuth enableHeader={false} enableSidebar={false} />,
    children: [
      { path: AppRoutes.organizationTypeSelect, element: <OrganizationTypeSelect /> },
      { path: AppRoutes.rsoCreate, element: <RsoCreate /> },
      { path: AppRoutes.companyCreate, element: <CompanyCreate /> },
    ],
  },
  {
    element: <AdminLayoutWithAuth />,
    children: [
      {
        path: AppRoutes.home,
        element: <Home />,
      },

      //Company
      { path: AppRoutes.companyList, element: <CompanyList /> },
      { path: AppRoutes.companyDetail, element: <CompanyDetail /> },
      { path: AppRoutes.companyEdit, element: <CompanyEdit /> },

      { path: AppRoutes.rsoList, element: <RsoList /> },
      { path: AppRoutes.rsoDetail, element: <RsoDetail /> },
      { path: AppRoutes.rsoEdit, element: <RsoEdit /> },

      { path: AppRoutes.information, element: <Information /> },
      { path: AppRoutes.informationCreate, element: <InformationCreate /> },
      { path: AppRoutes.informationEdit, element: <InformationEdit /> },

      { path: AppRoutes.convert, element: <ConvertList /> },
      { path: AppRoutes.convertHistory, element: <ConvertHistoryList /> },
      { path: AppRoutes.convertDetail, element: <ConvertDetail /> },

      { path: AppRoutes.masterData, element: <MasterDataList /> },
      { path: AppRoutes.masterDataDetail, element: <MasterDataDetail /> },

      //contact
      { path: AppRoutes.contactList, element: <ContactList isCompany={false} /> },
      { path: AppRoutes.contactDetail, element: <ContactDetail isCompany={false} /> },
      { path: AppRoutes.contactTypeCreate, element: <ContactTypeCreate isCompany={false} /> },
      { path: AppRoutes.contactTypeEdit, element: <ContactTypeEdit isCompany={false} /> },
      //company contact
      { path: AppRoutes.companyContactList, element: <ContactList isCompany={true} /> },
      { path: AppRoutes.companyContactDetail, element: <ContactDetail isCompany={true} /> },
      { path: AppRoutes.companyContactTypeCreate, element: <ContactTypeCreate isCompany={true} /> },
      { path: AppRoutes.companyContactTypeEdit, element: <ContactTypeEdit isCompany={true} /> },

      //chat
      { path: AppRoutes.chat, element: <Chat /> },
      { path: AppRoutes.chatDetail, element: <Chat /> },
      { path: AppRoutes.companyChat, element: <Chat isCompany={true} /> },
      { path: AppRoutes.companyChatDetail, element: <Chat isCompany={true} /> },

      { path: AppRoutes.setting, element: <Setting /> },
    ],
  },
  {
    path: AppRoutes.logout,
    element: <Logout />,
  },
  { path: AppRoutes.serverErrorPage, element: <ServerErrorPage /> },
  { path: "*", element: <PageNotFound /> },
];
